export enum CMDTYPES {
  PaymentGatewayRequest = 99,
  PaymentWindowCreditCardRequest = 100,
  PaymentWindowCreditCardResponse = 101,
  PassDataEncryptRequest = 200,
  PassCertResponse = 201,
  VersionCheck = 1000,
  MajorNotice = 1001,
  SessionCheck = 1002,
  PushTokenUpdate = 1003,
  OtpCertRequest = 1004,
  OtpCertSubmit = 1005,
  TermsList = 1006,
  Join = 1007,
  AutoLogin = 1008,
  Logout = 1009,
  Cancel = 1010,
  ServiceTerms = 1011,
  KTMVNO = 1012,
  KAKAOMAPINFOAUTHUPDATE = 1013,
  KAKAOMAPINFOAUTH = 1014,
  walletImminentCoupon = 1019,
  walletCouponList = 1020,
  CategoryList = 1021,
  BrandList = 1022,
  CouponListByBrand = 1023,
  PopularBrandList = 1024,
  BannerList = 1025,
  MdPickCouponList = 1026,
  RecommendBrandList = 1027,
  MostViewedCouponList = 1028,
  SearchRecommendWord = 1030,
  SearchPopularCoupon = 1031,
  SearchSubmit = 1032,
  walletCouponUsedCheck = 1040,
  PurchaseCouponList = 1041,
  PurchaseCouponDetail = 1042,
  FavoriteUpdate = 1043,
  PurchaseValidCheck = 1044,
  PurchaseCouponCancel = 1045,
  RefundSubmit = 1046,
  RefundTelecomCertFileSubmit = 1047,
  RefundBankList = 1048,
  CancelCouponValidCheck = 1049,
  CouponPurchasedInfo = 1050,
  AlwaysCouponDetailInfo = 1061,
  AlwaysCouponListByCategory = 1062,
  HotDealCouponList = 1063,
  HotDealDetailInfo = 1064,
  CouponDetailInfoTab = 1065,
  FreeCouponList = 1066,
  FreeCouponDetail = 1067,
  SelfRegisterCouponList = 1070,
  SelfRegisterCouponDetail = 1071,
  SelfRegisterCouponImageUpload = 1072,
  SelfRegisterCouponCreate = 1073,
  SelfRegisterCouponUpdate = 1074,
  SelfRegisterCouponDelete = 1075,
  SelfRegisterCouponImageDelete = 1076,
  HotDealPurchaseLimitInfo = 1077,
  NotificationReceivedList = 1080,
  NotificationReceivedUpdate = 1081,
  JoinWithOtpCertSubmit = 1107,
  // EasyLogin = 1092,
  PassCertCheck = 2000,
  GiftMsgCardList = 2010,
  GiftPaymentWindowCreditCardRequest = 2011,
  GiftSendPurchased = 2012,
  GiftDetailInfoByOrderId = 2013,
  GiftDetailInfoByGiftIdx = 2014,
  GiftedCouponList = 2015,
  GiftedCouponDetail = 2016,
  GiftReceiveAccept = 2018,
  GiftReceiveReject = 2019,
  GiftSendCancel = 2020,
  GiftRefundSubmit = 2021,
  GiftShareUrlInfo = 2022,
  GiftTransMsgResult = 2023,
  GiftHotDealList = 2024,
  CheckVulerable = 2025,
  DownloadCouponPathCheck = 2040,
}
